import React from 'react'
import { useHistory } from 'react-router-dom'
import { equals, pathOr } from 'ramda'
import { useAuth, UserPermission } from '@/auth'
import useComapnyCode from '@/hooks/useComapnyCode'
import localStorageUtil from '@/utils/localstorage'

export default function usePageGhgQuery() {
  const { user } = useAuth()
  const history = useHistory()
  const companyCode = useComapnyCode()

  const pathname = history.location.pathname

  const routeAuth = React.useMemo(() => {
    const authUrl = companyCode ? pathname.replace(companyCode, ':companyCode') : pathname

    return pathOr({}, ['authByUrl', authUrl], user) as UserPermission
  }, [user, pathname, companyCode])

  /**
   * menu_std: ghg|iso
   */
  const isGHGProtocol = React.useMemo(() => equals(localStorageUtil.get('menu_std'), 'ghg'), [])

  const paramValue = React.useMemo(() => {
    if (isGHGProtocol && routeAuth?.param) {
      const value = routeAuth?.param?.split('=')[1]

      return Number(value)
    }

    return
  }, [routeAuth, isGHGProtocol])

  // 其他類別 others-emission, iso 帶 null
  const othersCategory = React.useMemo(() => {
    if (pathname.indexOf('others-emission') > -1) {
      if (!isGHGProtocol) {
        return null
      }

      const ghg = pathname.split('/').pop()
      return ghg === 'ghg_other_1' ? 1 : ghg === 'ghg_other_2' ? 2 : 0
    }
  }, [pathname, isGHGProtocol])

  return {
    boundType: paramValue,
    prodType: paramValue,
    othersCategory,
    isGHGProtocol,
  }
}
